import { IOffer } from 'types';
import { IImportOffer } from '../../types';

export enum OfferActionTypes {
  GET_ACTIVE_OFFERS = '@@student/GET_ACTIVE_OFFERS',
  GET_ACTIVE_OFFERS_SUCCESS = '@@student/GET_ACTIVE_OFFERS_SUCCESS',
  GET_ACTIVE_OFFERS_FAILURE = '@@student/GET_ACTIVE_OFFERS_FAILURE',
  SET_ACTIVE_OFFER = '@@student/SET_ACTIVE_OFFER',
  SET_ACTIVE_OFFER_SUCCESS = '@@student/SET_ACTIVE_OFFER_SUCCESS',
  SET_ACTIVE_OFFER_FAILURE = '@@student/SET_ACTIVE_OFFER_FAILURE'
}

export interface OffersState {
  offers?: Array<IOffer>;
  activeOffer?: IOffer | IImportOffer | null;
}
